<template>
      <div class="service">
           <div class="LeftMenu">
               <div class="menuList"v-for="(itemService,indexService) in serviceArray" :key="indexService"
                    :class="itemService.id === serviceChoose ? 'choose-active' : ''" @click="choose(itemService)">{{itemService.name}}</div>
           </div>
           <div class="rightContent">
                <template v-if="serviceChoose==='1'">
                    <div class="aboutElegance">
                      治疗过程中有任何疑问，可随时咨询您的专属健康顾问。一对一为您提供康复治疗的咨询与指导服务，包括但不限于图文、电话、微信视频等方式提供指导服务。并定期跟进您的康复状态和治疗需求，实时为您提供定制化方案调整。
                    </div>
                  <div class="aboutElegance">
                      电话：400 633 8080
                  </div>
                </template>
                <template v-if="serviceChoose==='2'">
                  <div class="aboutElegance">长沙高新开发区岳麓西大道1689号综合楼101六楼</div>
                </template>
           </div>
      </div>
</template>

<script>

export default {
  name: 'service',
  data () {
    return {
      serviceChoose: '1',
      serviceArray:[
        {
          name:'电话',
          id:'1',
        },
        {
          name:'地址',
          id:'2',
        }
      ],
    }
  },
  beforeMount() {

  },
  methods: {
    choose(item){
      this.serviceChoose = item.id
    },
  },
}
</script>

<style scoped>
.service{
  overflow-y: hidden;
  width: 100%;
  height: 100%;
  padding: 0% 0%  0% 10%;
  box-sizing: border-box;
  display: flex;
}
.LeftMenu {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  padding-top: 4%;
  box-sizing: border-box;
}

.menuList {
  font-size: 0.3rem;
  padding: 0.2rem 0.1rem;
  background: #f1efef;
  color: #5a5959;
  margin-bottom: 0.1rem;
  cursor: pointer;
}

.choose-active {
  color: #fff;
  background: #cc9f59;
  margin-bottom: 0.2rem;
}

.rightContent {
  flex: 1 1 auto;
  height: 100%;
  overflow: auto;
  padding:4% 10% 4% 4%;
  box-sizing: border-box;
}

.aboutElegance {
  font-size: 0.34rem;
  margin-bottom: 0.3rem;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/ServiceCenter.vue